import {
  AccordionContent,
  AccordionHeading,
} from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { DeliveryInformation } from '@moonpig/web-shared-products'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import { AccordionSections } from '../types'
import { useProductContext } from '../../../../contexts/product'

export const DeliveryDetailsModule: FC = () => {
  const [{ product, departmentInfo }] = useProductContext()

  const localiseText = useCoreLocaleText()

  const deliveryInformation =
    product.category.department !== DepartmentsEnum.DIGITAL_GIFT_CARDS
      ? departmentInfo.longDeliveryInfo
      : undefined

  return (
    <AccordionContent
      heading={
        <AccordionHeading level="h2">
          {localiseText('common.delivery_options')}
        </AccordionHeading>
      }
      value={AccordionSections.Delivery}
    >
      <DeliveryInformation
        department={product.category.department}
        deliveryInformation={deliveryInformation}
      />
    </AccordionContent>
  )
}
